import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Login from "../Components/Login/Login.jsx";
import Signup from "../Components/Signup/Signup.jsx";
import Verification from "../Components/Signup/Verifycation.jsx";
import { useContext } from "react";
import { Logindetail } from "../context/Logindetail.js";
import Logout from "../Components/Login/Logout.jsx";
import { Forgatpwd } from "../Components/Login/Forgatpwd.jsx";
import { FaShoppingCart, FaHome, FaInfoCircle, FaPhoneAlt, FaRegHeart, FaHeart } from "react-icons/fa";
import { MdOutlineShoppingCart, MdStorefront } from "react-icons/md";
import { GiGoldBar } from "react-icons/gi";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer,toast } from "react-toastify";

import { Button, Badge } from "reactstrap";
import { decrement, increment, setWishlistCount, setCount } from "../store/slices/counterSlice.jsx";
import { GetWishlist_fun } from "../api/wishlist_api.js";
import { GetCartList_Fun } from "../api/Scheme2.js";
// import toast from "react-hot-toast";
// import toast from "react-hot-toast";

export default function Headers({ setting_datas, openScheme, setopenScheme }) {
  const [getphone, setphone] = useState();

  const location = useLocation();
  const { pathname } = location;
  const { detail_info, token } = useContext(Logindetail);
  const navigate = useNavigate();
  const [viewRole, setViewRole] = useState()


  const triggerModel = (params) => {
    localStorage.setItem("roleType", params);
    const loginRole = document.getElementById("loginRole");
    if (loginRole) {
      loginRole.value = params;
    }

    // Programmatically trigger the login modal if it's not already open
    const modalElement = document.getElementById("loginmodalview");
    if (modalElement && !modalElement.classList.contains('show')) {
      // Use the generic hidden trigger to avoid overriding the role we just set
      const trigger = document.getElementById("openLoginModalNow");
      if (trigger) {
        trigger.click();
      }
    }

    document.getElementById("chooseOpenOtpclose")?.click();
  };

  useEffect(() => {
    if (location.state?.authRequired && !token) {
      // Small timeout to allow the path transition to finish
      setTimeout(() => {
        triggerModel("2");
      }, 300);
      // Clear the state
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, token, navigate]);

  useEffect(() => {
    const modalElement = document.getElementById("loginmodalview");

    const handleHidden = () => {
      // If modal is hidden while still not logged in on protected pages, go home
      // Check localStorage for the token to get the most up-to-date value
      const currentToken = localStorage.getItem("green_token");
      if (!currentToken && (location.pathname === "/cart" || location.pathname === "/user/wishlist")) {
        navigate("/");
      }
    };

    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleHidden);
    }
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleHidden);
      }
    };
  }, [location.pathname, navigate]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      GetWishlist_fun().then(res => {
        dispatch(setWishlistCount(res?.data?.length || 0));
      });
      GetCartList_Fun().then(res => {
        dispatch(setCount(res?.carts?.length || 0));
      });
    } else {
      dispatch(setWishlistCount(0));
      dispatch(setCount(0));
    }
  }, [token, dispatch]);

  const count = useSelector((state) => state.counter.value);
  const wishlistCount = useSelector((state) => state.counter.wishlistValue);

  const handleClick = () => {
    if (!token) {
      localStorage.setItem("redirectPath", "/cart");
      triggerModel("2");
      return; // stay on current page, just show login popup
    }
    navigate("/cart");
  };

  const handleWishlistClick = () => {
    if (!token) {
      localStorage.setItem("redirectPath", "/user/wishlist");
      triggerModel("2");
      return; // stay on current page, just show login popup
    }
    navigate("/user/wishlist");
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "/assets/images/green1.png";
    if (String(imagePath).startsWith("http")) return imagePath;

    const base_url_env = process.env.REACT_APP_BASE_URL || "";
    const baseUrl = base_url_env.replace("/api/v1/", "/");
    return `${baseUrl}${imagePath}`;
  };

  return (
    <>
      <style>
        {`
          @media (min-width: 1024px) and (max-width: 1440px) {
            .header-container-80 {
              padding-left: 0.5rem !important;
              padding-right: 0.5rem !important;
            }
            .navbar-nav .nav-link {
              white-space: nowrap !important;
              font-weight: 800 !important;
              font-size: 13px !important;
              padding-left: 0.5rem !important;
              padding-right: 0.2rem !important;
            }
            .navbar-nav {
              gap: 0.25rem !important;
              flex-wrap: nowrap !important;
            }
            .btn_sig {
               font-size: 13px !important;
               padding: 5px 10px !important;
               white-space: nowrap !important;
            }
            .header-container-80 > .d-flex.align-items-center {
               gap: 0.25rem !important;
            }
            .header-container-80 > .d-flex.align-items-center header {
               padding: 5px !important;
            }
          }

          /* ── Top Nav Social Icons Hover Effect ── */
          .top-social-links a {
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .top-social-links a:hover {
            transform: scale(1.18);
            filter: brightness(1.2) drop-shadow(0 0 5px rgba(255,255,255,0.3));
          }
          .top-social-links img, .top-social-links svg {
            transition: inherit;
          }
        `}
      </style>
      <button id="loginPopupopen" onClick={() => triggerModel("2")} className="d-none"></button>
      <button id="openLoginModalNow" data-bs-toggle="modal" data-bs-target="#loginmodalview" className="d-none"></button>
      <header id="sticky" className="sticky">
        <div className="header">
          <div className="top_nav">
            <div className="container">
              <div className="d-flex flex-wrap align-items-center justify-content-sm-between justify-content-between ">
                <div className=" d-sm-block d-none d-sm-flex align-items-center justify-content-md-start  justify-content-sm-center  gap-sm-1 gap-md-3">
                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <img src="/assets/iocns/call.png" alt="" />
                    <a
                      className="text-white m-0"
                      href={`tel:+${setting_datas[0]?.phone}`}
                      data-rel="external"
                      rel="noreferrer"
                    >
                      <h6 className="text-wrap lh-base m-0">
                        {setting_datas[0]?.phone}
                      </h6>
                    </a>
                  </div>
                  <div className="line d-none d-sm-block"></div>
                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <img src="/assets/iocns/Mail.png" alt="" />
                    <a
                      className="text-white"
                      href={`mailto:${setting_datas[0]?.support_mail}`}
                      data-rel="external"
                      rel="noreferrer"
                    >
                      <h6 className="text-wrap lh-base m-0">
                        {setting_datas[0]?.support_mail}
                      </h6>
                    </a>
                  </div>
                </div>

                <div className="mb-logo d-block d-sm-none">
                  <Link to="/">
                    {" "}
                    <img
                      src={getImageUrl(setting_datas[0]?.logo)}
                      className="mainIcon"
                      alt="logo"
                    />
                  </Link>
                </div>

                <div className="d-flex align-items-center justify-content-sm-start gap-md-3 gap-sm-2 gap-2 top-social-links">
                  {/* <a
                    href="/franchise"
                    title="Franchise"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <MdStorefront size={22} color="#ffffff" />
                  </a> */}
                  <a
                    href={setting_datas[0]?.facebook}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    <img
                      src="/assets/iocns/Facebook.png"
                      alt=""
                    />{" "}
                  </a>
                  <a
                    href={setting_datas[0]?.instagram}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    <img src="/assets/iocns/insta.png" alt="" />{" "}
                  </a>
                  <a
                    href={setting_datas[0]?.twitter}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="/assets/iocns/X.png" alt="" />
                  </a>
                  <a
                    href={setting_datas[0]?.youtube}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    <img src="/assets/iocns/Youtube.png" alt="" />
                  </a>
                  {/* <a
                    href={setting_datas[0]?.linkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    <img
                      src="/assets/iocns/Linkedin.png"
                      alt="linkedin_img"
                    />{" "}
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <nav className="navbar navbar-expand-lg  bottom_nav">
            <div className="container-fluid px-2 px-md-5 header-container-80">
              <Link to="/">
                {" "}
                <img
                  src={getImageUrl(setting_datas[0]?.logo)}
                  className="mainIcon d-none d-sm-block"
                  alt="logo"
                />
              </Link>
              <div className="toggle-bar-mb">
                {/* <div className='d-lg-none d-md-block dropdown-toggle' type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                 <img alt='' src={detail_info?.avatar ?? '/assets/images/user.jfif'} onError={(e) => e.currentTarget.src = '/assets/images/user.jfif'} />
                                 <div class="dropdown mobile-profile">
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            {
                                                token && detail_info ? (
                                                    <>
                                                        <div className='mb-user'>
                                                            <button type='button' className='btn btn_sig' >
                                                                Dashboard
                                                            </button>
                                                        </div>
                                                        <div className='mb-user'>
                                                            <button  type='button'  className='btn btn_sig'>
                                                                My Account
                                                            </button>
                                                        </div>
                                                        <div className='mb-user'>
                                                            <button  type='button'  className='btn btn_sig' data-bs-toggle="modal" data-bs-target="#logout_modal"  >
                                                                Logout
                                                            </button>
                                                        </div>

                                                    </>
                                                ) : (
                                                    <>
                                                        <div className='mb-user'>
                                                            <button type='button' className='btn btn_sig' id='loginPopupopen' data-bs-toggle="modal" data-bs-target="#loginmodalview"  >
                                                                LOGIN
                                                            </button>
                                                        </div>

                                                        <div className='mb-user'>
                                                            <button type='button' className='btn  btn_sig ' data-bs-toggle="modal" data-bs-target="#signupmodalview">
                                                                SIGNUP
                                                            </button>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    </div>

                                </div> */}
                <button
                  className="navbar-toggler d-block d-sm-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarScroll"
                  aria-controls="navbarScroll"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                {token && detail_info ? (
                  <div className="dropdown show top-drop d-lg-none d-block ">
                    <a
                      className="border-0 gap-2 btn dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        alt=""
                        src={detail_info?.avatar ?? "/assets/images/user.jfif"}
                        onError={(e) =>
                          (e.currentTarget.src = "/assets/images/user.jfif")
                        }
                      />
                      <span className="mx-2 fw-bold text-uppercase mb-logname">
                        {detail_info?.name}
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <Link className="dropdown-item" to="/user/dashboard">
                          My Dashboard
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/user/account-setup"
                        >
                          My Account
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to=""
                          data-bs-toggle="modal"
                          data-bs-target="#logout_modal"
                        >
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <>
                    {/* <div className='d-flex align-items-center d-lg-none d-block  gap-1'>
                                                <div className='part_button d-flex align-items-center d-lg-none d-block  gap-1'>
                                                    <button type='button' onClick={() => { triggerModel('1') }} id='loginPopupopen' data-bs-toggle="modal" data-bs-target="#loginmodalview" ><img alt='' src='/assets/iocns/handshake_img.png' /></button>
                                                </div>
                                                <button type='button' onClick={() => setphone(localStorage.getItem('phone'))} className='btn d-none btn_sig ' data-bs-toggle="modal" data-bs-target="#signupmodalview">
                                                    Signup
                                                </button>
                                            </div> */}

                    <div className="d-flex align-items-center d-lg-none d-block  gap-1">
                      <div className="part_button d-flex align-items-center d-lg-none d-block  gap-1">
                        <button
                          type="button"
                          onClick={() => {
                            triggerModel("1");
                          }}
                          id="loginPopupopenAgentMobile"
                          data-bs-toggle="modal"
                          data-bs-target="#loginmodalview"
                          title="Agent Login"
                        >
                          <img alt="" src="/assets/iocns/handshake_img.png" />




                        </button>
                      </div>
                      <button
                        type="button"
                        onClick={() => setphone(localStorage.getItem("phone"))}
                        className="btn d-none btn_sig "
                        data-bs-toggle="modal"
                        data-bs-target="#signupmodalview"
                      >
                        Signup
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          // triggerModel("2");
                          triggerModel("2");
                        }}
                        className="btn btn_sig mb-login"
                        id="loginPopupopenUserMobile"
                        data-bs-toggle="modal"
                        data-bs-target="#loginmodalview"
                      >
                        Login / Signup
                      </button>

                      <button
                        type="button"
                        onClick={() => setphone(localStorage.getItem("phone"))}
                        className="btn d-none btn_sig  mb-login"
                        id="openRegistermodal"
                        data-bs-toggle="modal"
                        data-bs-target="#signupmodalview"
                      >
                        Signup
                      </button>
                    </div>
                  </>
                )}
                <button
                  className="navbar-toggler d-none d-sm-block d-lg-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarScroll"
                  aria-controls="navbarScroll"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
              </div>

              <div className="collapse navbar-collapse" id="navbarScroll">
                <ul className="navbar-nav gap-lg-3  mx-auto my-2 my-lg-0 navbar-nav-scroll">
                  <li className="nav-item">
                    <Link
                      to={"/"}
                      className={
                        pathname == "/" ? "nav_active nav-link" : "nav-link"
                      }
                      aria-current="page"
                    >
                      Home
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to={"/gold"}
                      className={
                        pathname == "/gold"
                          ? "nav_active nav-link"
                          : "nav-link"
                      }
                    >
                      Gold Jewellery
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to={"/silver"}
                      className={
                        pathname == "/silver"
                          ? "nav_active nav-link"
                          : "nav-link"
                      }
                    >
                      Silver Jewellery
                    </Link>
                  </li>

                  {/* <li className="nav-item">
                                        <Link to={'/scheme'} className={pathname == '/scheme' ? "nav_active nav-link" : "nav-link"} >Greenheap Scheme</Link>
                                    </li> */}
                  <li className="nav-item">
                    <Link
                      to={"/contact"}
                      className={
                        pathname == "/contact"
                          ? "nav_active nav-link"
                          : "nav-link"
                      }
                    >
                      Contact Us
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to={"/franchise"}
                      className={
                        pathname == "/franchise"
                          ? "nav_active nav-link"
                          : "nav-link"
                      }
                    >
                      Franchise Locator
                    </Link>
                  </li>


                  <li>
                    <div
                      onClick={handleClick}
                      data-bs-toggle={!token ? "modal" : ""}
                      data-bs-target={!token ? "#loginmodalview" : ""}
                      className="d-inline-block d-md-none mt-2"
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <div style={{ position: "relative", display: "inline-block", marginRight: 6 }}>
                        {count > 0 ? <FaShoppingCart size={24} /> : <MdOutlineShoppingCart size={24} />}
                        {count > 0 && (
                          <Badge
                            color="danger"
                            pill
                            style={{
                              position: "absolute",
                              top: -6,
                              right: -10,
                              fontSize: "0.65rem",
                              padding: "4px 6px",
                            }}
                          >
                            {count}
                          </Badge>
                        )}
                      </div>
                      <span style={{ fontSize: "0.9rem", fontWeight: 500 }}>Cart</span>
                    </div>
                  </li>

                  <li className="nav-item">
                    <div
                      onClick={handleWishlistClick}
                      data-bs-toggle={!token ? "modal" : ""}
                      data-bs-target={!token ? "#loginmodalview" : ""}
                      className="d-inline-block d-md-none mt-2"
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <div style={{ position: "relative", display: "inline-block", marginRight: 6 }}>
                        {wishlistCount > 0 ? <FaHeart size={24} /> : <FaRegHeart size={24} />}
                        {wishlistCount > 0 && (
                          <Badge
                            color="danger"
                            pill
                            style={{
                              position: "absolute",
                              top: -6,
                              right: -10,
                              fontSize: "0.65rem",
                              padding: "4px 6px",
                            }}
                          >
                            {wishlistCount}
                          </Badge>
                        )}
                      </div>
                      <span style={{ fontSize: "0.9rem", fontWeight: 500 }}>Wishlist</span>
                    </div>
                  </li>

                </ul>

                {token && detail_info ? (
                  <div className="dropdown show top-drop d-lg-block d-none ">
                    <a
                      className="border-0 gap-2 btn dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        alt=""
                        src={detail_info?.avatar ?? "/assets/images/user.jfif"}
                        onError={(e) =>
                          (e.currentTarget.src = "/assets/images/user.jfif")
                        }
                      />
                      <span className="mx-2 fw-bold text-uppercase">
                        {detail_info?.name}
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <Link className="dropdown-item" to="/user/dashboard">
                          My Dashboard
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/user/account-setup"
                        >
                          My Account
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to=""
                          data-bs-toggle="modal"
                          data-bs-target="#logout_modal"
                        >
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <>
                    <div className="d-flex align-items-center d-lg-flex d-none gap-lg-3">
                      <div className="part_button d-flex align-items-center d-lg-block d-none  gap-1">
                        <button
                          type="button"
                          onClick={() => {
                            triggerModel("1");
                          }}
                          id="loginPopupopenAgentDesktop"
                          data-bs-toggle="modal"
                          data-bs-target="#loginmodalview"
                          title="Agent Login"
                        >
                          <img alt="" src="/assets/iocns/handshake_img.png" />{" "}
                          {/* Agent / Vendor / Franchise */}
                        </button>
                      </div>
                      <button
                        type="button"
                        onClick={() => setphone(localStorage.getItem("phone"))}
                        className="btn d-none btn_sig"
                        id="openAgentRegistermodal"
                        data-bs-toggle="modal"
                        data-bs-target="#agentsmodalview"
                      >
                        Signup
                      </button>
                    </div>
                    <div className="d-flex align-items-center d-lg-flex d-none gap-lg-3 mx-lg-3">
                      <button
                        type="button"
                        onClick={() => triggerModel("2")}
                        className="btn btn_sig"
                        id="loginPopupopenUserDesktop"
                        data-bs-toggle="modal"
                        data-bs-target="#loginmodalview"
                      >
                        <img alt="user" width="32" height="32" src="/assets/iocns/User_login.png"/>
                        Login / Signup
                      </button>

                      <button
                        type="button"
                        onClick={() => setphone(localStorage.getItem("phone"))}
                        className="btn d-none btn_sig "
                        data-bs-toggle="modal"
                        data-bs-target="#signupmodalview"
                      >
                        Signup
                      </button>
                    </div>
                  </>
                )}
              </div>
              <div className="d-flex align-items-center gap-lg-4 gap-3">
                <div
                  onClick={handleWishlistClick}
                  data-bs-toggle={!token ? "modal" : ""}
                  data-bs-target={!token ? "#loginmodalview" : ""}
                >
                  <header
                    style={{
                      padding: 10,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      cursor: "pointer"
                    }}
                    className="d-none d-md-block"
                  >
                    <div style={{ position: "relative", display: "inline-block" }}>
                      {wishlistCount > 0 ? <FaHeart size={24} /> : <FaRegHeart size={24} />}
                      {wishlistCount > 0 && (
                        <Badge
                          color="danger"
                          pill
                          style={{
                            position: "absolute",
                            top: -5,
                            right: -10,
                            fontSize: "0.75rem",
                          }}
                        >
                          {wishlistCount}
                        </Badge>
                      )}
                    </div>
                  </header>
                </div>
                <div
                  onClick={handleClick}
                  data-bs-toggle={!token ? "modal" : ""}
                  data-bs-target={!token ? "#loginmodalview" : ""}
                >
                  <header
                    style={{
                      padding: 10,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      cursor: "pointer"
                    }}
                    className="d-none d-md-block"
                  >
                    <div style={{ position: "relative", display: "inline-block" }}>
                      {count > 0 ? <FaShoppingCart size={24} /> : <MdOutlineShoppingCart size={24} />}
                      {count > 0 && (
                        <Badge
                          color="danger"
                          pill
                          style={{
                            position: "absolute",
                            top: -5,
                            right: -10,
                            fontSize: "0.75rem",
                          }}
                        >
                          {count}
                        </Badge>
                      )}
                    </div>
                  </header>
                </div>
              </div>





            </div>
          </nav>
        </div>
      </header>

      <Login openSchemes={openScheme} setopenScheme={setopenScheme} />

      <Signup phone={getphone} />

      <Logout />

      <Forgatpwd />
    </>
  );
}
